import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";
import { onlyRoleCategories, onlyUserRoles } from "./constants";

export const requestGetUserRoles = async () => {
    const [result, err] = await doRequest(
        "/Usuario/ListarRoles", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.roles
        .filter(({ idRol }) => onlyUserRoles(idRol))
        .map(({
            idRol, nombre,
            idCategoria
        }) => ({
            id: idRol,
            categoryId: idCategoria,
            name: nombre
        }));
}
export const requestGetRoleCategories = async () => {
    const [result, err] = await doRequest(
        "/Usuario/ListarCategorias", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.categorias
        .filter(({ idCategoria }) => onlyRoleCategories(idCategoria))
        .map(({
            idCategoria, nombre
        }) => ({
            id: idCategoria,
            name: nombre
        }));
}